module.exports = __webpack_public_path__ + "static/media/Illus-StoreOpening@3x.93bf363a.png";